<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { putAction,getAction } from '@/api/manage'
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('近一年月用水/缴费统计'),
            option: {},
            url: {
                list: '/jeecg-charge/meter/waterAnalysis/waterUseAndPay',
            },
            lineData: {
                monthStrList:[],
                payMoneyList: [],
                waterUseList: []
            }
        }
    },
    mounted() {

    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.$refs.option.showLoading('default',{
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                })
                this.resetData()
                this.queryWaterUseAndPay()
            })
            
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        queryWaterUseAndPay() {
            putAction(this.url.list, {}).then((res) => {
                if(res.success){
                    this.lineData.monthStrList = res.result.monthStrList
                    this.lineData.payMoneyList = res.result.payMoneyList
                    this.lineData.waterUseList = res.result.waterUseList
                    this.setOption()
                }
            })
        },
        setOption() {
            let seriesData = []
            let category = [this.$t('用水量'),this.$t('缴费')]
            this.$refs.option.hideLoading()
            this.option = {
                color: ['#FECA20','#50E3C2', '#32C5FF','#0091FF','#0394FF','#4634FA','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'],
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 4,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'cross',
                        lineStyle: {
                            color: '#019AF3'
                        },
                        label: {
                            backgroundColor: '#000439',
                            color: 'rgb(0, 250, 254)'
                        },
                        crossStyle: {
                            color: 'rgb(0, 250, 254)'
                        }
                    }
                },
                legend: {
                    data: category,
                    selectedMode: false,
                    textStyle: {
                        color: '#CEE2FF'
                    },
                    icon: 'circle',
                    itemHeight: 10,
                    right: '4%',
                },
                grid: {
                    left: '3%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: this.lineData.monthStrList,
                    splitLine: {
                        show: false
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: ['#074671'],
                        }
                    },
                    axisLabel: {
                        color: '#CEE2FF',
                        fontSize: 10
                    }
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('用量(m³)'),
                    nameTextStyle: {
                        color: '#CEE2FF',
                        // /align: 'right'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: ['#074671'],
                        }
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#CEE2FF',
                        fontSize: 10
                    }
                },
                {
                    type: 'value',
                    name: this.$t('缴费(元)'),
                    nameTextStyle: {
                        color: '#CEE2FF',
                        align: 'left',
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#CEE2FF',
                        fontSize: 10
                    }
                }
                ],
                series: [
                    {
                        type: 'bar',
                        name: category[0],
                        data: this.lineData.waterUseList,
                        barMaxWidth: 14,
                        animationDuration: 2000,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: '#00D2FF'},
                                        {offset: 1, color: '#3A7BD5'}
                                    ]
                                ),
                                barBorderRadius:20
                            }
                        },
                    },
                    {
                        type: 'line',
                        yAxisIndex: 1,
                        name: category[1],
                        data: this.lineData.payMoneyList,
                        smooth: true,
                        symbol: 'circle',
                        animationDelay: 1000,
                        itemStyle: {
                            normal: {
                                color: '#F5A623',
                                borderColor: '#F5A623',
                                lineStyle: {
                                    color: "#F5A623" //折线的颜色
                                }
                            }
                        },
                    }
                ]
            };
        }
    }
}
</script>